import ReactGA from "react-ga4";

import { envSwitch, isLocalhost } from "@connect/Env";

export default function initGoogleAnalytics() {
	const analyticsID = envSwitch("G-E51WQBPZ9Z", "G-CFDCJ03YFE", "G-W80EGG795L");

	ReactGA.initialize(analyticsID, { testMode: isLocalhost(), nonce: "NGINX_CSP_NONCE" });
}